module.exports = __webpack_public_path__ + "static/media/v27.469c2873.mp4";